<body class="vision-light-theme" (click)="refreshActivityTimer()">
  <router-outlet />
</body>
